const normalizeBaseUrl = value => value.replace(/\/$/, '');

function requireEnvVar(name) {
  const value = process.env[name];

  if (typeof value !== 'string' || value.trim().length === 0) {
    const message = `[FATAL] Missing required environment variable: ${name}. Set this in your .env/.env.local file and restart the app.`;
    console.error(message);
    throw new Error(message);
  }

  return normalizeBaseUrl(value.trim());
}

function optionalEnvVar(name) {
  const value = process.env[name];
  if (typeof value !== 'string' || value.trim().length === 0) {
    return null;
  }
  return normalizeBaseUrl(value.trim());
}

/**
 * Feature flag: when `true`, auth + CMS-data traffic routes to the new BKFC
 * CMS API (apps/api in the bkfc-cms repo) instead of the legacy bkfc-backend
 * proxy. Off by default so existing behavior is byte-identical until a
 * caller explicitly opts in. See src/services/cms/ for the adapters this
 * unlocks (home rails, playback, resume).
 */
export const USE_CMS_BACKEND = process.env.REACT_APP_USE_CMS_BACKEND === 'true';

/**
 * Base URL for the new BKFC CMS API. Auth (`/auth/*`), content
 * (`/events`, `/fighters`, `/news`, ...), home (`/app/load`, `/v1/home/:slug`),
 * resume (`/v1/resume`), and playback (`/v1/playback/:contentId`) all mount at
 * the root of this one service — see apps/api/src/app.ts in bkfc-cms.
 *
 * Required when the flag is on (auth/content resolve to it); read optionally
 * even when the flag is off so the new src/services/cms/ adapters can be
 * exercised standalone (e.g. from a dev tool or a future non-flag-gated call
 * site) without forcing every environment to define it today.
 */
export const CMS_API_BASE_URL = USE_CMS_BACKEND
  ? requireEnvVar('REACT_APP_CMS_API_URL')
  : optionalEnvVar('REACT_APP_CMS_API_URL');

export const AUTH_API_BASE_URL = USE_CMS_BACKEND
  ? CMS_API_BASE_URL
  : requireEnvVar('REACT_APP_AUTH_API_URL');

export const CMS_DATA_API_BASE_URL = USE_CMS_BACKEND
  ? CMS_API_BASE_URL
  : requireEnvVar('REACT_APP_CMS_DATA_API_URL');
